import React from 'react';
import AddProductWizard from '../components/AddProduct/AddProductWizard';

const AddProductPage = () => {
  return <AddProductWizard />;
};

export default AddProductPage;
